import React from 'react';
import MenuIcon from '@material-ui/icons/Menu';

class ProjectsMenu extends React.Component {
  render() {
    return (
      <div
        className="projects-sidebar-icon"
        onClick={this.props.openProjectsSidebar}
      >
        <MenuIcon className="hamburgerMenu" /> <span>Projects</span>
      </div>
    );
  }
}
export default ProjectsMenu;
